// Backend (multer) multipart dosya adını latin1 okuyup öyle kaydediyordu:
// "profıl.jpeg" → "profÄ±l.jpeg". Middleware artık yüklemede düzeltiyor, ama
// daha önce bozuk kaydedilmiş satırlar için listelemede de onarıyoruz.
// Yalnızca tamamen latin1 aralığında olup geçerli UTF-8 olarak yeniden
// okunabilen isimler değişir; "Süreç.pdf" gibi gerçek isimler aynen kalır.
export function utf8FileName(name) {
  if (!name || typeof name !== "string" || /[^\u0000-ÿ]/.test(name)) return name;
  try {
    return decodeURIComponent(escape(name));
  } catch (e) {
    return name;
  }
}

export function repairFileNames(rows) {
  if (!Array.isArray(rows)) return rows;
  return rows.map((row) => {
    if (!row || typeof row.fileName !== "string") return row;
    const fixed = utf8FileName(row.fileName);
    return fixed === row.fileName ? row : { ...row, fileName: fixed };
  });
}
